import type { FetcherOptions } from "@/modules/fetch/types"

/**
 * Handle headers that are common to both client and server.
 */
export const generateCommonHeadersFromOptions = (options: FetcherOptions): HeadersInit => {
  const { serviceDomain, withDefaultContentType = true } = options
  const method = options?.requestInit?.method || "GET"
  const headers: HeadersInit = {}

  // Cache-Control: no-cache is added to all GET requests by default
  // It will just force the browser to check with the server if the resource has changed
  if (method.toUpperCase() === "GET") {
    headers["Cache-Control"] = "no-cache"
  }

  if (withDefaultContentType) {
    headers["Content-Type"] = "application/json"
  }

  if (serviceDomain === "MONOLITH_API") {
    headers.Accept = "application/json"
  }

  if (serviceDomain === "APIGW_IN_KRAKEND_API") {
    headers.Accept = "application/vnd.jobteaser.v1+jsonpb"
    if (withDefaultContentType) {
      headers["Content-Type"] = "application/vnd.jobteaser.v1+jsonpb"
    }
  }

  if (serviceDomain === "KRAKEND_API") {
    headers.Accept = "application/json"
  }

  return {
    ...headers,
  }
}
